export default __webpack_public_path__ + "static/media/footer-image.43b9e679.png";